export const footerLinks = {
    'de-de': [
        {
            title: 'Top-Destinationen',
            items: [
                {
                    href: 'https://www.wingie.de/flug/nach-stuttgart/',
                    title: 'Stuttgart',
                },
                {
                    href: 'https://www.wingie.de/flug/nach-berlin/',
                    title: 'Berlin',
                },
                {
                    href: 'https://www.wingie.de/flug/nach-hamburg/',
                    title: 'Hamburg',
                },
                {
                    href: 'https://www.wingie.de/flug/nach-palma-de-mallorca/',
                    title: 'Palma de Mallorca',
                },
                {
                    href: 'https://www.wingie.de/flug/nach-new-york/',
                    title: 'New York',
                },
                {
                    href: 'https://www.wingie.de/flug/nach-casablanca/',
                    title: 'Casablanca',
                },
            ],
        },
        {
            title: 'Beliebte Länder',
            items: [
                {
                    href: 'https://www.wingie.de/flug/at-oesterreich/',
                    title: 'Österreich',
                },
                {
                    href: 'https://www.wingie.de/flug/cn-china/',
                    title: 'China',
                },
                {
                    href: 'https://www.wingie.de/flug/dk-daenemark/',
                    title: 'Dänemark',
                },
                {
                    href: 'https://www.wingie.de/flug/fr-frankreich/',
                    title: 'Frankreich',
                },
                {
                    href: 'https://www.wingie.de/flug/gr-griechenland/',
                    title: 'Griechenland',
                },
                {
                    href: 'https://www.wingie.de/flug/it-italien/',
                    title: 'Italien',
                },
            ],
        },
        {
            title: 'Beliebte Fluggesellschaften',
            items: [
                {
                    href: 'https://www.wingie.de/flug/airlines/lufthansa/',
                    title: 'Lufthansa',
                },
                {
                    href: 'https://www.wingie.de/flug/airlines/eurowings/',
                    title: 'Eurowings',
                },
                {
                    href: 'https://www.wingie.de/flug/airlines/condor/',
                    title: 'Condor',
                },
                {
                    href: 'https://www.wingie.de/flug/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://www.wingie.de/flug/airlines/sun-express/',
                    title: 'SunExpress',
                },
                {
                    href: 'https://www.wingie.de/flug/airlines/pegasus/',
                    title: 'Pegasus',
                },
            ],
        },
    ],
    'de-en': [
        {
            title: 'Top Destinations',
            items: [
                {
                    href: 'https://www.wingie.de/en/flights/to-stuttgart/',
                    title: 'Stuttgart',
                },
                {
                    href: 'https://www.wingie.de/en/flights/to-berlin/',
                    title: 'Berlin',
                },
                {
                    href: 'https://www.wingie.de/en/flights/to-ham-hamburg/',
                    title: 'Hamburg',
                },
                {
                    href: 'https://www.wingie.de/en/flights/to-palma-de-mallorca/',
                    title: 'Palma De Mallorca',
                },
                {
                    href: 'https://www.wingie.de/en/flights/to-new-york/',
                    title: 'New York',
                },
                {
                    href: 'https://www.wingie.de/en/flights/to-casablanca/',
                    title: 'Casablanca',
                },
            ],
        },
        {
            title: 'Popular Countries',
            items: [
                {
                    href: 'https://www.wingie.de/en/flights/at-austria/',
                    title: 'Austria',
                },
                {
                    href: 'https://www.wingie.de/en/flights/cn-china/',
                    title: 'China',
                },
                {
                    href: 'https://www.wingie.de/en/flights/dk-denmark/',
                    title: 'Denmark',
                },
                {
                    href: 'https://www.wingie.de/en/flights/fr-france/',
                    title: 'France',
                },
                {
                    href: 'https://www.wingie.de/en/flights/gr-greece/',
                    title: 'Greece',
                },
                {
                    href: 'https://www.wingie.de/en/flights/it-italy/',
                    title: 'Italy',
                },
            ],
        },
        {
            title: 'Popular Airlines',
            items: [
                {
                    href: 'https://www.wingie.de/en/flights/airlines/lufthansa/',
                    title: 'Lufthansa',
                },
                {
                    href: 'https://www.wingie.de/en/flights/airlines/eurowings/',
                    title: 'Eurowings',
                },
                {
                    href: 'https://www.wingie.de/en/flights/airlines/condor/',
                    title: 'Condor',
                },
                {
                    href: 'https://www.wingie.de/en/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://www.wingie.de/en/flights/airlines/sun-express/',
                    title: 'SunExpress',
                },
                {
                    href: 'https://www.wingie.de/en/flights/airlines/pegasus/',
                    title: 'Pegasus',
                },
            ],
        },
    ],
    'de-es': [
        {
            title: 'Principales destinos',
            items: [
                {
                    href: 'https://www.wingie.de/es/vuelos/a-stuttgart/',
                    title: 'Stuttgart',
                },
                {
                    href: 'https://www.wingie.de/es/vuelos/a-berlin/',
                    title: 'Berlin',
                },
                {
                    href: 'https://www.wingie.de/es/vuelos/a-ham-hamburg/',
                    title: 'Hamburg',
                },
                {
                    href: 'https://www.wingie.de/es/vuelos/a-palma-de-mallorca/',
                    title: 'Palma De Mallorca',
                },
                {
                    href: 'https://www.wingie.de/es/vuelos/a-new-york/',
                    title: 'New York',
                },
                {
                    href: 'https://www.wingie.de/es/vuelos/a-casablanca/',
                    title: 'Casablanca',
                },
            ],
        },
        {
            title: 'Países populares',
            items: [
                {
                    href: 'https://www.wingie.de/es/vuelos/at-austria/',
                    title: 'Austria',
                },
                {
                    href: 'https://www.wingie.de/es/vuelos/cn-china/',
                    title: 'China',
                },
                {
                    href: 'https://www.wingie.de/es/vuelos/dk-denmark/',
                    title: 'Dinamarca',
                },
                {
                    href: 'https://www.wingie.de/es/vuelos/fr-france/',
                    title: 'Francia',
                },
                {
                    href: 'https://www.wingie.de/es/vuelos/gr-greece/',
                    title: 'Grecia',
                },
                {
                    href: 'https://www.wingie.de/es/vuelos/it-italy/',
                    title: 'Italia',
                },
            ],
        },
        {
            title: 'Aerolíneas populares',
            items: [
                {
                    href: 'https://www.wingie.de/es/vuelos/companias-aereas/lufthansa/',
                    title: 'Lufthansa',
                },
                {
                    href: 'https://www.wingie.de/es/vuelos/companias-aereas/eurowings/',
                    title: 'Eurowings',
                },
                {
                    href: 'https://www.wingie.de/es/vuelos/companias-aereas/condor/',
                    title: 'Condor',
                },
                {
                    href: 'https://www.wingie.de/es/vuelos/companias-aereas/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://www.wingie.de/es/vuelos/companias-aereas/sun-express/',
                    title: 'SunExpress',
                },
                {
                    href: 'https://www.wingie.de/es/vuelos/companias-aereas/pegasus/',
                    title: 'Pegasus',
                },
            ],
        },
    ],
    'de-ru': [
        {
            title: 'Популярные направления',
            items: [
                {
                    href: 'https://www.wingie.de/ru/flights/to-stuttgart/',
                    title: 'Штутгарт',
                },
                {
                    href: 'https://www.wingie.de/ru/flights/to-berlin/',
                    title: 'Берлин',
                },
                {
                    href: 'https://www.wingie.de/ru/flights/to-hamburg/',
                    title: 'Гамбург',
                },
                {
                    href: 'https://www.wingie.de/ru/flights/to-palma-mallorca/',
                    title: 'Пальма Майорка',
                },
                {
                    href: 'https://www.wingie.de/ru/flights/to-new-york/',
                    title: 'Нью-Йорк',
                },
                {
                    href: 'https://www.wingie.de/ru/flights/to-casablanca/',
                    title: 'Касабланка',
                },
            ],
        },
        {
            title: 'Популярные страны',
            items: [
                {
                    href: 'https://www.wingie.de/ru/flights/at-austria/',
                    title: 'Австрия',
                },
                {
                    href: 'https://www.wingie.de/ru/flights/cn-china/',
                    title: 'Китай',
                },
                {
                    href: 'https://www.wingie.de/ru/flights/dk-denmark/',
                    title: 'Дания',
                },
                {
                    href: 'https://www.wingie.de/ru/flights/fr-france/',
                    title: 'Франция',
                },
                {
                    href: 'https://www.wingie.de/ru/flights/gr-greece/',
                    title: 'Греция',
                },
                {
                    href: 'https://www.wingie.de/ru/flights/it-italy/',
                    title: 'Италия',
                },
            ],
        },
        {
            title: 'Популярные авиакомпании',
            items: [
                {
                    href: 'https://www.wingie.de/ru/flights/airlines/lufthansa/',
                    title: 'Lufthansa',
                },
                {
                    href: 'https://www.wingie.de/ru/flights/airlines/eurowings/',
                    title: 'Eurowings',
                },
                {
                    href: 'https://www.wingie.de/ru/flights/airlines/condor/',
                    title: 'Condor',
                },
                {
                    href: 'https://www.wingie.de/ru/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://www.wingie.de/ru/flights/airlines/sun-express/',
                    title: 'SunExpress',
                },
                {
                    href: 'https://www.wingie.de/ru/flights/airlines/pegasus/',
                    title: 'Pegasus',
                },
            ],
        },
    ],
    'de-ar': [
        {
            title: 'أفضل الوجهات',
            items: [
                {
                    href: 'https://www.wingie.de/ar/flights/to-stuttgart/',
                    title: 'شتوتغارت',
                },
                {
                    href: 'https://www.wingie.de/ar/flights/to-berlin/',
                    title: 'برلين',
                },
                {
                    href: 'https://www.wingie.de/ar/flights/to-hamburg/',
                    title: 'هامبورغ',
                },
                {
                    href: 'https://www.wingie.de/ar/flights/to-palma-mallorca/',
                    title: 'بالما مايوركا',
                },
                {
                    href: 'https://www.wingie.de/ar/flights/to-new-york/',
                    title: 'نيويورك',
                },
                {
                    href: 'https://www.wingie.de/ar/flights/to-casablanca/',
                    title: 'الدار البيضاء',
                },
            ],
        },
        {
            title: 'أشهر الدول',
            items: [
                {
                    href: 'https://www.wingie.de/ar/flights/at-austria/',
                    title: 'النمسا',
                },
                {
                    href: 'https://www.wingie.de/ar/flights/cn-china/',
                    title: 'الصين',
                },
                {
                    href: 'https://www.wingie.de/ar/flights/dk-denmark/',
                    title: 'الدنمارك',
                },
                {
                    href: 'https://www.wingie.de/ar/flights/fr-france/',
                    title: 'فرنسا',
                },
                {
                    href: 'https://www.wingie.de/ar/flights/gr-greece/',
                    title: 'اليونان',
                },
                {
                    href: 'https://www.wingie.de/ar/flights/it-italy/',
                    title: 'إيطاليا',
                },
            ],
        },
        {
            title: 'أشهر الخطوط الجوية',
            items: [
                {
                    href: 'https://www.wingie.de/ar/flights/airlines/lufthansa/',
                    title: 'لوفتهانزا',
                },
                {
                    href: 'https://www.wingie.de/ar/flights/airlines/eurowings/',
                    title: 'Eurowings',
                },
                {
                    href: 'https://www.wingie.de/ar/flights/airlines/condor/',
                    title: 'Condor',
                },
                {
                    href: 'https://www.wingie.de/ar/flights/airlines/turkish-airlines/',
                    title: 'الخطوط الجوية التركية',
                },
                {
                    href: 'https://www.wingie.de/ar/flights/airlines/sun-express/',
                    title: 'سن اكسبرس',
                },
                {
                    href: 'https://www.wingie.de/ar/flights/airlines/pegasus/',
                    title: 'خطوط بيغاسوس\n',
                },
            ],
        },
    ],
    'de-it': [
        {
            title: 'Destinazioni Top',
            items: [
                { title: 'Stoccarda', href: 'https://www.wingie.de/it/flights/to-stuttgart/' },
                { title: 'Berlino', href: 'https://www.wingie.de/it/flights/to-berlin/' },
                { title: 'Amburgo', href: 'https://www.wingie.de/it/flights/to-hamburg/' },
                { title: 'Palma de Mallorca', href: 'https://www.wingie.de/it/flights/to-palma-de-mallorca/' },
                { title: 'New York', href: 'https://www.wingie.de/it/flights/to-new-york/' },
                { title: 'Casablanca', href: 'https://www.wingie.de/it/flights/to-casablanca/' },
            ],
        },
        {
            title: 'Paesi Popolari',
            items: [
                { title: 'Austria', href: 'https://www.wingie.de/it/flights/at-austria/' },
                { title: 'Cina', href: 'https://www.wingie.de/it/flights/cn-cina/' },
                { title: 'Danimarca', href: 'https://www.wingie.de/it/flights/dk-danimarca/' },
                { title: 'Francia', href: 'https://www.wingie.de/it/flights/fr-francia/' },
                { title: 'Grecia', href: 'https://www.wingie.de/it/flights/gr-grecia/' },
                { title: 'Italia', href: 'https://www.wingie.de/it/flights/it-italia/' },
            ],
        },
        {
            title: 'Compagnie Aeree Popolari',
            items: [
                { title: 'Lufthansa', href: 'https://www.wingie.de/it/flights/airlines/lufthansa/' },
                { title: 'Eurowings', href: 'https://www.wingie.de/it/flights/airlines/eurowings/' },
                { title: 'Condor', href: 'https://www.wingie.de/it/flights/airlines/condor/' },
                { title: 'Turkish Airlines', href: 'https://www.wingie.de/it/flights/airlines/turkish-airlines/' },
                { title: 'SunExpress', href: 'https://www.wingie.de/it/flights/airlines/sun-express/' },
                { title: 'Pegasus', href: 'https://www.wingie.de/it/flights/airlines/pegasus/' },
            ],
        },
    ],
    'de-fr': [
        {
            title: 'Destinations Populaires',
            items: [
                { title: 'Stuttgart', href: 'https://www.wingie.de/fr/flights/to-stuttgart/' },
                { title: 'Berlin', href: 'https://www.wingie.de/fr/flights/to-berlin/' },
                { title: 'Hambourg', href: 'https://www.wingie.de/fr/flights/to-hamburg/' },
                { title: 'Palma de Majorque', href: 'https://www.wingie.de/fr/flights/to-palma-de-mallorca/' },
                { title: 'New York', href: 'https://www.wingie.de/fr/flights/to-new-york/' },
                { title: 'Casablanca', href: 'https://www.wingie.de/fr/flights/to-casablanca/' },
            ],
        },
        {
            title: 'Pays Populaires',
            items: [
                { title: 'Autriche', href: 'https://www.wingie.de/fr/flights/at-autriche/' },
                { title: 'Chine', href: 'https://www.wingie.de/fr/flights/cn-chine/' },
                { title: 'Danemark', href: 'https://www.wingie.de/fr/flights/dk-danemark/' },
                { title: 'France', href: 'https://www.wingie.de/fr/flights/fr-france/' },
                { title: 'Grèce', href: 'https://www.wingie.de/fr/flights/gr-grecia/' },
                { title: 'Italie', href: 'https://www.wingie.de/fr/flights/it-italie/' },
            ],
        },
        {
            title: 'Compagnies Aériennes Populaires',
            items: [
                { title: 'Lufthansa', href: 'https://www.wingie.de/fr/flights/airlines/lufthansa/' },
                { title: 'Eurowings', href: 'https://www.wingie.de/fr/flights/airlines/eurowings/' },
                { title: 'Condor', href: 'https://www.wingie.de/fr/flights/airlines/condor/' },
                { title: 'Turkish Airlines', href: 'https://www.wingie.de/fr/flights/airlines/turkish-airlines/' },
                { title: 'SunExpress', href: 'https://www.wingie.de/fr/flights/airlines/sun-express/' },
                { title: 'Pegasus', href: 'https://www.wingie.de/fr/flights/airlines/pegasus/' },
            ],
        },
    ],
    'de-pt': [
        {
            title: 'Destinos Populares',
            items: [
                { title: 'Stuttgart', href: 'https://www.wingie.de/pt/flights/to-stuttgart/' },
                { title: 'Berlim', href: 'https://www.wingie.de/pt/flights/to-berlin/' },
                { title: 'Hamburgo', href: 'https://www.wingie.de/pt/flights/to-hamburg/' },
                { title: 'Palma de Mallorca', href: 'https://www.wingie.de/pt/flights/to-palma-de-mallorca/' },
                { title: 'Nova York', href: 'https://www.wingie.de/pt/flights/to-new-york/' },
                { title: 'Casablanca', href: 'https://www.wingie.de/pt/flights/to-casablanca/' },
            ],
        },
        {
            title: 'Países Populares',
            items: [
                { title: 'Áustria', href: 'https://www.wingie.de/pt/flights/at-austria/' },
                { title: 'China', href: 'https://www.wingie.de/pt/flights/cn-china/' },
                { title: 'Dinamarca', href: 'https://www.wingie.de/pt/flights/dk-dinamarca/' },
                { title: 'França', href: 'https://www.wingie.de/pt/flights/fr-franca/' },
                { title: 'Grécia', href: 'https://www.wingie.de/pt/flights/gr-grecia/' },
                { title: 'Itália', href: 'https://www.wingie.de/pt/flights/it-italia/' },
            ],
        },
        {
            title: 'Companhias Aéreas Populares',
            items: [
                { title: 'Lufthansa', href: 'https://www.wingie.de/pt/flights/airlines/lufthansa/' },
                { title: 'Eurowings', href: 'https://www.wingie.de/pt/flights/airlines/eurowings/' },
                { title: 'Condor', href: 'https://www.wingie.de/pt/flights/airlines/condor/' },
                { title: 'Turkish Airlines', href: 'https://www.wingie.de/pt/flights/airlines/turkish-airlines/' },
                { title: 'SunExpress', href: 'https://www.wingie.de/pt/flights/airlines/sun-express/' },
                { title: 'Pegasus', href: 'https://www.wingie.de/pt/flights/airlines/pegasus/' },
            ],
        },
    ],
    'de-ro': [
        {
            title: 'Destinații Populare',
            items: [
                { title: 'Stuttgart', href: 'https://www.wingie.de/ro/flights/to-stuttgart/' },
                { title: 'Berlin', href: 'https://www.wingie.de/ro/flights/to-berlin/' },
                { title: 'Hamburg', href: 'https://www.wingie.de/ro/flights/to-hamburg/' },
                { title: 'Palma de Mallorca', href: 'https://www.wingie.de/ro/flights/to-palma-de-mallorca/' },
                { title: 'New York', href: 'https://www.wingie.de/ro/flights/to-new-york/' },
                { title: 'Casablanca', href: 'https://www.wingie.de/ro/flights/to-casablanca/' },
            ],
        },
        {
            title: 'Țări Populare',
            items: [
                { title: 'Austria', href: 'https://www.wingie.de/ro/flights/at-austria/' },
                { title: 'China', href: 'https://www.wingie.de/ro/flights/cn-china/' },
                { title: 'Danemarca', href: 'https://www.wingie.de/ro/flights/dk-danemarca/' },
                { title: 'Franța', href: 'https://www.wingie.de/ro/flights/fr-franta/' },
                { title: 'Grecia', href: 'https://www.wingie.de/ro/flights/gr-grecia/' },
                { title: 'Italia', href: 'https://www.wingie.de/ro/flights/it-italia/' },
            ],
        },
        {
            title: 'Companii Aeriene Populare',
            items: [
                { title: 'Lufthansa', href: 'https://www.wingie.de/ro/flights/airlines/lufthansa/' },
                { title: 'Eurowings', href: 'https://www.wingie.de/ro/flights/airlines/eurowings/' },
                { title: 'Condor', href: 'https://www.wingie.de/ro/flights/airlines/condor/' },
                { title: 'Turkish Airlines', href: 'https://www.wingie.de/ro/flights/airlines/turkish-airlines/' },
                { title: 'SunExpress', href: 'https://www.wingie.de/ro/flights/airlines/sun-express/' },
                { title: 'Pegasus', href: 'https://www.wingie.de/ro/flights/airlines/pegasus/' },
            ],
        },
    ],
    'de-pl': [
        {
            title: 'Popularne Destynacje',
            items: [
                { title: 'Stuttgart', href: 'https://www.wingie.de/pl/flights/to-stuttgart/' },
                { title: 'Berlin', href: 'https://www.wingie.de/pl/flights/to-berlin/' },
                { title: 'Hamburg', href: 'https://www.wingie.de/pl/flights/to-hamburg/' },
                { title: 'Palma de Mallorca', href: 'https://www.wingie.de/pl/flights/to-palma-de-mallorca/' },
                { title: 'Nowy Jork', href: 'https://www.wingie.de/pl/flights/to-new-york/' },
                { title: 'Casablanca', href: 'https://www.wingie.de/pl/flights/to-casablanca/' },
            ],
        },
        {
            title: 'Popularne Kraje',
            items: [
                { title: 'Austria', href: 'https://www.wingie.de/pl/flights/at-austria/' },
                { title: 'Chiny', href: 'https://www.wingie.de/pl/flights/cn-chiny/' },
                { title: 'Dania', href: 'https://www.wingie.de/pl/flights/dk-dania/' },
                { title: 'Francja', href: 'https://www.wingie.de/pl/flights/fr-francja/' },
                { title: 'Grecja', href: 'https://www.wingie.de/pl/flights/gr-grecja/' },
                { title: 'Włochy', href: 'https://www.wingie.de/pl/flights/it-wlochy/' },
            ],
        },
        {
            title: 'Popularne Linie Lotnicze',
            items: [
                { title: 'Lufthansa', href: 'https://www.wingie.de/pl/flights/airlines/lufthansa/' },
                { title: 'Eurowings', href: 'https://www.wingie.de/pl/flights/airlines/eurowings/' },
                { title: 'Condor', href: 'https://www.wingie.de/pl/flights/airlines/condor/' },
                { title: 'Turkish Airlines', href: 'https://www.wingie.de/pl/flights/airlines/turkish-airlines/' },
                { title: 'SunExpress', href: 'https://www.wingie.de/pl/flights/airlines/sun-express/' },
                { title: 'Pegasus', href: 'https://www.wingie.de/pl/flights/airlines/pegasus/' },
            ],
        },
    ],
    'de-lt': [
        {
            title: 'Populiarūs Kryptys',
            items: [
                { title: 'Štutgartas', href: 'https://www.wingie.de/lt/flights/to-stuttgart/' },
                { title: 'Berlynas', href: 'https://www.wingie.de/lt/flights/to-berlin/' },
                { title: 'Hamburgas', href: 'https://www.wingie.de/lt/flights/to-hamburg/' },
                { title: 'Palma de Maljorka', href: 'https://www.wingie.de/lt/flights/to-palma-de-mallorca/' },
                { title: 'Niujorkas', href: 'https://www.wingie.de/lt/flights/to-new-york/' },
                { title: 'Kasablanka', href: 'https://www.wingie.de/lt/flights/to-casablanca/' },
            ],
        },
        {
            title: 'Populiarios Šalys',
            items: [
                { title: 'Austrija', href: 'https://www.wingie.de/lt/flights/at-austrija/' },
                { title: 'Kinija', href: 'https://www.wingie.de/lt/flights/cn-kinija/' },
                { title: 'Danija', href: 'https://www.wingie.de/lt/flights/dk-danija/' },
                { title: 'Prancūzija', href: 'https://www.wingie.de/lt/flights/fr-prancuzija/' },
                { title: 'Graikija', href: 'https://www.wingie.de/lt/flights/gr-graikija/' },
                { title: 'Italija', href: 'https://www.wingie.de/lt/flights/it-italija/' },
            ],
        },
        {
            title: 'Populiarios Oro Linijos',
            items: [
                { title: 'Lufthansa', href: 'https://www.wingie.de/lt/flights/airlines/lufthansa/' },
                { title: 'Eurowings', href: 'https://www.wingie.de/lt/flights/airlines/eurowings/' },
                { title: 'Condor', href: 'https://www.wingie.de/lt/flights/airlines/condor/' },
                { title: 'Turkish Airlines', href: 'https://www.wingie.de/lt/flights/airlines/turkish-airlines/' },
                { title: 'SunExpress', href: 'https://www.wingie.de/lt/flights/airlines/sun-express/' },
                { title: 'Pegasus', href: 'https://www.wingie.de/lt/flights/airlines/pegasus/' },
            ],
        },
    ],
    'de-uz': [
        {
            title: "Mashhur Yo'nalishlar",
            items: [
                { title: 'Shtutgart', href: 'https://www.wingie.de/uz/flights/to-stuttgart/' },
                { title: 'Berlin', href: 'https://www.wingie.de/uz/flights/to-berlin/' },
                { title: 'Gamburg', href: 'https://www.wingie.de/uz/flights/to-hamburg/' },
                { title: 'Palma de Majorka', href: 'https://www.wingie.de/uz/flights/to-palma-de-mallorca/' },
                { title: 'Nyu-York', href: 'https://www.wingie.de/uz/flights/to-new-york/' },
                { title: 'Kasablanka', href: 'https://www.wingie.de/uz/flights/to-casablanca/' },
            ],
        },
        {
            title: 'Mashhur Davlatlar',
            items: [
                { title: 'Avstriya', href: 'https://www.wingie.de/uz/flights/at-avstriya/' },
                { title: 'Xitoy', href: 'https://www.wingie.de/uz/flights/cn-xitoy/' },
                { title: 'Daniya', href: 'https://www.wingie.de/uz/flights/dk-daniya/' },
                { title: 'Fransiya', href: 'https://www.wingie.de/uz/flights/fr-fransiya/' },
                { title: 'Gretsiya', href: 'https://www.wingie.de/uz/flights/gr-gretsiya/' },
                { title: 'Italiya', href: 'https://www.wingie.de/uz/flights/it-italiya/' },
            ],
        },
        {
            title: 'Mashhur Aviakompaniyalar',
            items: [
                { title: 'Lufthansa', href: 'https://www.wingie.de/uz/flights/airlines/lufthansa/' },
                { title: 'Eurowings', href: 'https://www.wingie.de/uz/flights/airlines/eurowings/' },
                { title: 'Condor', href: 'https://www.wingie.de/uz/flights/airlines/condor/' },
                { title: 'Turkish Airlines', href: 'https://www.wingie.de/uz/flights/airlines/turkish-airlines/' },
                { title: 'SunExpress', href: 'https://www.wingie.de/uz/flights/airlines/sun-express/' },
                { title: 'Pegasus', href: 'https://www.wingie.de/uz/flights/airlines/pegasus/' },
            ],
        },
    ],
    'de-sr': [
        {
            title: 'Popularne Destinacije',
            items: [
                { title: 'Štutgart', href: 'https://www.wingie.de/sr/flights/to-stuttgart/' },
                { title: 'Berlin', href: 'https://www.wingie.de/sr/flights/to-berlin/' },
                { title: 'Hamburg', href: 'https://www.wingie.de/sr/flights/to-hamburg/' },
                { title: 'Palma de Majorka', href: 'https://www.wingie.de/sr/flights/to-palma-de-mallorca/' },
                { title: 'Njujork', href: 'https://www.wingie.de/sr/flights/to-new-york/' },
                { title: 'Kazablanka', href: 'https://www.wingie.de/sr/flights/to-casablanca/' },
            ],
        },
        {
            title: 'Popularne Zemlje',
            items: [
                { title: 'Austrija', href: 'https://www.wingie.de/sr/flights/at-austrija/' },
                { title: 'Kina', href: 'https://www.wingie.de/sr/flights/cn-kina/' },
                { title: 'Danska', href: 'https://www.wingie.de/sr/flights/dk-danska/' },
                { title: 'Francuska', href: 'https://www.wingie.de/sr/flights/fr-francuska/' },
                { title: 'Grčka', href: 'https://www.wingie.de/sr/flights/gr-grcka/' },
                { title: 'Italija', href: 'https://www.wingie.de/sr/flights/it-italija/' },
            ],
        },
        {
            title: 'Popularne Avio-kompanije',
            items: [
                { title: 'Lufthansa', href: 'https://www.wingie.de/sr/flights/airlines/lufthansa/' },
                { title: 'Eurowings', href: 'https://www.wingie.de/sr/flights/airlines/eurowings/' },
                { title: 'Condor', href: 'https://www.wingie.de/sr/flights/airlines/condor/' },
                { title: 'Turkish Airlines', href: 'https://www.wingie.de/sr/flights/airlines/turkish-airlines/' },
                { title: 'SunExpress', href: 'https://www.wingie.de/sr/flights/airlines/sun-express/' },
                { title: 'Pegasus', href: 'https://www.wingie.de/sr/flights/airlines/pegasus/' },
            ],
        },
    ],
    'de-ky': [
        {
            title: 'Популярдуу Багыттар',
            items: [
                { title: 'Штутгарт', href: 'https://www.wingie.de/ky/flights/to-stuttgart/' },
                { title: 'Берлин', href: 'https://www.wingie.de/ky/flights/to-berlin/' },
                { title: 'Гамбург', href: 'https://www.wingie.de/ky/flights/to-hamburg/' },
                { title: 'Пальма де Майорка', href: 'https://www.wingie.de/ky/flights/to-palma-de-mallorca/' },
                { title: 'Нью-Йорк', href: 'https://www.wingie.de/ky/flights/to-new-york/' },
                { title: 'Касабланка', href: 'https://www.wingie.de/ky/flights/to-casablanca/' },
            ],
        },
        {
            title: 'Популярдуу Өлкөлөр',
            items: [
                { title: 'Австрия', href: 'https://www.wingie.de/ky/flights/at-austria/' },
                { title: 'Кытай', href: 'https://www.wingie.de/ky/flights/cn-china/' },
                { title: 'Дания', href: 'https://www.wingie.de/ky/flights/dk-denmark/' },
                { title: 'Франция', href: 'https://www.wingie.de/ky/flights/fr-france/' },
                { title: 'Греция', href: 'https://www.wingie.de/ky/flights/gr-greece/' },
                { title: 'Италия', href: 'https://www.wingie.de/ky/flights/it-italy/' },
            ],
        },
        {
            title: 'Популярдуу Авиакомпаниялар',
            items: [
                { title: 'Lufthansa', href: 'https://www.wingie.de/ky/flights/airlines/lufthansa/' },
                { title: 'Eurowings', href: 'https://www.wingie.de/ky/flights/airlines/eurowings/' },
                { title: 'Condor', href: 'https://www.wingie.de/ky/flights/airlines/condor/' },
                { title: 'Turkish Airlines', href: 'https://www.wingie.de/ky/flights/airlines/turkish-airlines/' },
                { title: 'SunExpress', href: 'https://www.wingie.de/ky/flights/airlines/sun-express/' },
                { title: 'Pegasus', href: 'https://www.wingie.de/ky/flights/airlines/pegasus/' },
            ],
        },
    ],
    'de-tg': [
        {
            title: 'Масҳуртарин Самтҳо',
            items: [
                { title: 'Штутгарт', href: 'https://www.wingie.de/tg/flights/to-stuttgart/' },
                { title: 'Берлин', href: 'https://www.wingie.de/tg/flights/to-berlin/' },
                { title: 'Гамбург', href: 'https://www.wingie.de/tg/flights/to-hamburg/' },
                { title: 'Палма де Мајорка', href: 'https://www.wingie.de/tg/flights/to-palma-de-mallorca/' },
                { title: 'Ню Йорк', href: 'https://www.wingie.de/tg/flights/to-new-york/' },
                { title: 'Касабланка', href: 'https://www.wingie.de/tg/flights/to-casablanca/' },
            ],
        },
        {
            title: 'Масҳуртарин Кишварҳо',
            items: [
                { title: 'Австрия', href: 'https://www.wingie.de/tg/flights/at-austria/' },
                { title: 'Чин', href: 'https://www.wingie.de/tg/flights/cn-china/' },
                { title: 'Дания', href: 'https://www.wingie.de/tg/flights/dk-denmark/' },
                { title: 'Фаронса', href: 'https://www.wingie.de/tg/flights/fr-france/' },
                { title: 'Юнон', href: 'https://www.wingie.de/tg/flights/gr-greece/' },
                { title: 'Италия', href: 'https://www.wingie.de/tg/flights/it-italy/' },
            ],
        },
        {
            title: 'Масҳуртарин Авиакомпанияҳо',
            items: [
                { title: 'Lufthansa', href: 'https://www.wingie.de/tg/flights/airlines/lufthansa/' },
                { title: 'Eurowings', href: 'https://www.wingie.de/tg/flights/airlines/eurowings/' },
                { title: 'Condor', href: 'https://www.wingie.de/tg/flights/airlines/condor/' },
                { title: 'Turkish Airlines', href: 'https://www.wingie.de/tg/flights/airlines/turkish-airlines/' },
                { title: 'SunExpress', href: 'https://www.wingie.de/tg/flights/airlines/sun-express/' },
                { title: 'Pegasus', href: 'https://www.wingie.de/tg/flights/airlines/pegasus/' },
            ],
        },
    ],
    'de-kk': [
        {
            title: 'Танымал Бағыттар',
            items: [
                { title: 'Штутгарт', href: 'https://www.wingie.de/kk/flights/to-stuttgart/' },
                { title: 'Берлин', href: 'https://www.wingie.de/kk/flights/to-berlin/' },
                { title: 'Гамбург', href: 'https://www.wingie.de/kk/flights/to-hamburg/' },
                { title: 'Пальма де Майорка', href: 'https://www.wingie.de/kk/flights/to-palma-de-mallorca/' },
                { title: 'Нью-Йорк', href: 'https://www.wingie.de/kk/flights/to-new-york/' },
                { title: 'Касабланка', href: 'https://www.wingie.de/kk/flights/to-casablanca/' },
            ],
        },
        {
            title: 'Танымал Елдер',
            items: [
                { title: 'Австрия', href: 'https://www.wingie.de/kk/flights/at-austria/' },
                { title: 'Қытай', href: 'https://www.wingie.de/kk/flights/cn-china/' },
                { title: 'Дания', href: 'https://www.wingie.de/kk/flights/dk-denmark/' },
                { title: 'Франция', href: 'https://www.wingie.de/kk/flights/fr-france/' },
                { title: 'Греция', href: 'https://www.wingie.de/kk/flights/gr-greece/' },
                { title: 'Италия', href: 'https://www.wingie.de/kk/flights/it-italy/' },
            ],
        },
        {
            title: 'Танымал Авиакомпаниялар',
            items: [
                { title: 'Lufthansa', href: 'https://www.wingie.de/kk/flights/airlines/lufthansa/' },
                { title: 'Eurowings', href: 'https://www.wingie.de/kk/flights/airlines/eurowings/' },
                { title: 'Condor', href: 'https://www.wingie.de/kk/flights/airlines/condor/' },
                { title: 'Turkish Airlines', href: 'https://www.wingie.de/kk/flights/airlines/turkish-airlines/' },
                { title: 'SunExpress', href: 'https://www.wingie.de/kk/flights/airlines/sun-express/' },
                { title: 'Pegasus', href: 'https://www.wingie.de/kk/flights/airlines/pegasus/' },
            ],
        },
    ],
    'de-nl': [
        {
            title: 'Populaire Bestemmingen',
            items: [
                { title: 'Stuttgart', href: 'https://www.wingie.de/nl/flights/to-stuttgart/' },
                { title: 'Berlijn', href: 'https://www.wingie.de/nl/flights/to-berlin/' },
                { title: 'Hamburg', href: 'https://www.wingie.de/nl/flights/to-hamburg/' },
                { title: 'Palma de Mallorca', href: 'https://www.wingie.de/nl/flights/to-palma-de-mallorca/' },
                { title: 'New York', href: 'https://www.wingie.de/nl/flights/to-new-york/' },
                { title: 'Casablanca', href: 'https://www.wingie.de/nl/flights/to-casablanca/' },
            ],
        },
        {
            title: 'Populaire Landen',
            items: [
                { title: 'Oostenrijk', href: 'https://www.wingie.de/nl/flights/at-oostenrijk/' },
                { title: 'China', href: 'https://www.wingie.de/nl/flights/cn-china/' },
                { title: 'Denemarken', href: 'https://www.wingie.de/nl/flights/dk-denemarken/' },
                { title: 'Frankrijk', href: 'https://www.wingie.de/nl/flights/fr-frankrijk/' },
                { title: 'Griekenland', href: 'https://www.wingie.de/nl/flights/gr-griekenland/' },
                { title: 'Italië', href: 'https://www.wingie.de/nl/flights/it-italie/' },
            ],
        },
        {
            title: 'Populaire Luchtvaartmaatschappijen',
            items: [
                { title: 'Lufthansa', href: 'https://www.wingie.de/nl/flights/airlines/lufthansa/' },
                { title: 'Eurowings', href: 'https://www.wingie.de/nl/flights/airlines/eurowings/' },
                { title: 'Condor', href: 'https://www.wingie.de/nl/flights/airlines/condor/' },
                { title: 'Turkish Airlines', href: 'https://www.wingie.de/nl/flights/airlines/turkish-airlines/' },
                { title: 'SunExpress', href: 'https://www.wingie.de/nl/flights/airlines/sun-express/' },
                { title: 'Pegasus', href: 'https://www.wingie.de/nl/flights/airlines/pegasus/' },
            ],
        },
    ],
    'de-ja': [
        {
            title: '人気の目的地',
            items: [
                { title: 'ラスベガス', href: 'https://www.wingie.de/ja/flights/to-las-vegas/' },
                { title: 'シカゴ', href: 'https://www.wingie.de/ja/flights/to-chicago/' },
                { title: 'マイアミ', href: 'https://www.wingie.de/ja/flights/to-miami/' },
                { title: 'カンクン', href: 'https://www.wingie.de/ja/flights/to-cancun/' },
                { title: 'ロンドン', href: 'https://www.wingie.de/ja/flights/to-london/' },
                { title: 'ホノルル', href: 'https://www.wingie.de/ja/flights/to-honolulu/' },
            ],
        },
        {
            title: '人気の国',
            items: [
                { title: 'カナダ', href: 'https://www.wingie.de/ja/flights/ca-canada/' },
                { title: '中国', href: 'https://www.wingie.de/ja/flights/cn-china/' },
                { title: 'コスタリカ', href: 'https://www.wingie.de/ja/flights/cr-costa-rica/' },
                { title: 'ドミニカ共和国', href: 'https://www.wingie.de/ja/flights/do-dominican-republic/' },
                { title: 'エルサルバドル', href: 'https://www.wingie.de/ja/flights/sv-el-salvador/' },
                { title: 'フランス', href: 'https://www.wingie.de/ja/flights/fr-france/' },
            ],
        },
        {
            title: '人気の航空会社',
            items: [
                { title: 'アメリカン・エアラインズ', href: 'https://www.wingie.de/ja/flights/airlines/american-airlines/' },
                { title: 'デルタ航空', href: 'https://www.wingie.de/ja/flights/airlines/delta-air-lines/' },
                { title: 'ユナイテッド航空', href: 'https://www.wingie.de/ja/flights/airlines/united-airlines/' },
                { title: 'アラスカ航空', href: 'https://www.wingie.de/ja/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.de/ja/flights/airlines/jetblue/' },
                { title: 'ハワイアン航空', href: 'https://www.wingie.de/ja/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'de-zh': [
        {
            title: '热门目的地',
            items: [
                { title: '拉斯维加斯', href: 'https://www.wingie.de/zh/flights/to-las-vegas/' },
                { title: '芝加哥', href: 'https://www.wingie.de/zh/flights/to-chicago/' },
                { title: '迈阿密', href: 'https://www.wingie.de/zh/flights/to-miami/' },
                { title: '坎昆', href: 'https://www.wingie.de/zh/flights/to-cancun/' },
                { title: '伦敦', href: 'https://www.wingie.de/zh/flights/to-london/' },
                { title: '火奴鲁鲁', href: 'https://www.wingie.de/zh/flights/to-honolulu/' },
            ],
        },
        {
            title: '热门国家',
            items: [
                { title: '加拿大', href: 'https://www.wingie.de/zh/flights/ca-canada/' },
                { title: '中国', href: 'https://www.wingie.de/zh/flights/cn-china/' },
                { title: '哥斯达黎加', href: 'https://www.wingie.de/zh/flights/cr-costa-rica/' },
                { title: '多米尼加共和国', href: 'https://www.wingie.de/zh/flights/do-dominican-republic/' },
                { title: '萨尔瓦多', href: 'https://www.wingie.de/zh/flights/sv-el-salvador/' },
                { title: '法国', href: 'https://www.wingie.de/zh/flights/fr-france/' },
            ],
        },
        {
            title: '热门航空公司',
            items: [
                { title: '美国航空', href: 'https://www.wingie.de/zh/flights/airlines/american-airlines/' },
                { title: '达美航空', href: 'https://www.wingie.de/zh/flights/airlines/delta-air-lines/' },
                { title: '美联航', href: 'https://www.wingie.de/zh/flights/airlines/united-airlines/' },
                { title: '阿拉斯加航空', href: 'https://www.wingie.de/zh/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.de/zh/flights/airlines/jetblue/' },
                { title: '夏威夷航空', href: 'https://www.wingie.de/zh/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'de-ko': [
        {
            title: '인기 목적지',
            items: [
                { title: '라스베이거스', href: 'https://www.wingie.de/ko/flights/to-las-vegas/' },
                { title: '시카고', href: 'https://www.wingie.de/ko/flights/to-chicago/' },
                { title: '마이애미', href: 'https://www.wingie.de/ko/flights/to-miami/' },
                { title: '칸쿤', href: 'https://www.wingie.de/ko/flights/to-cancun/' },
                { title: '런던', href: 'https://www.wingie.de/ko/flights/to-london/' },
                { title: '호놀룰루', href: 'https://www.wingie.de/ko/flights/to-honolulu/' },
            ],
        },
        {
            title: '인기 국가',
            items: [
                { title: '캐나다', href: 'https://www.wingie.de/ko/flights/ca-canada/' },
                { title: '중국', href: 'https://www.wingie.de/ko/flights/cn-china/' },
                { title: '코스타리카', href: 'https://www.wingie.de/ko/flights/cr-costa-rica/' },
                { title: '도미니카 공화국', href: 'https://www.wingie.de/ko/flights/do-dominican-republic/' },
                { title: '엘살바도르', href: 'https://www.wingie.de/ko/flights/sv-el-salvador/' },
                { title: '프랑스', href: 'https://www.wingie.de/ko/flights/fr-france/' },
            ],
        },
        {
            title: '인기 항공사',
            items: [
                { title: '아메리칸 항공', href: 'https://www.wingie.de/ko/flights/airlines/american-airlines/' },
                { title: '델타 항공', href: 'https://www.wingie.de/ko/flights/airlines/delta-air-lines/' },
                { title: '유나이티드 항공', href: 'https://www.wingie.de/ko/flights/airlines/united-airlines/' },
                { title: '알래스카 항공', href: 'https://www.wingie.de/ko/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.de/ko/flights/airlines/jetblue/' },
                { title: '하와이안 항공', href: 'https://www.wingie.de/ko/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'de-hi': [
        {
            title: 'लोकप्रिय गंतव्य',
            items: [
                { title: 'लास वेगास', href: 'https://www.wingie.de/hi/flights/to-las-vegas/' },
                { title: 'शिकागो', href: 'https://www.wingie.de/hi/flights/to-chicago/' },
                { title: 'मियामी', href: 'https://www.wingie.de/hi/flights/to-miami/' },
                { title: 'कैनकन', href: 'https://www.wingie.de/hi/flights/to-cancun/' },
                { title: 'लंदन', href: 'https://www.wingie.de/hi/flights/to-london/' },
                { title: 'होनोलुलु', href: 'https://www.wingie.de/hi/flights/to-honolulu/' },
            ],
        },
        {
            title: 'लोकप्रिय देश',
            items: [
                { title: 'कनाडा', href: 'https://www.wingie.de/hi/flights/ca-canada/' },
                { title: 'चीन', href: 'https://www.wingie.de/hi/flights/cn-china/' },
                { title: 'कोस्टा रिका', href: 'https://www.wingie.de/hi/flights/cr-costa-rica/' },
                { title: 'डोमिनिकन गणराज्य', href: 'https://www.wingie.de/hi/flights/do-dominican-republic/' },
                { title: 'अल सल्वाडोर', href: 'https://www.wingie.de/hi/flights/sv-el-salvador/' },
                { title: 'फ्रांस', href: 'https://www.wingie.de/hi/flights/fr-france/' },
            ],
        },
        {
            title: 'लोकप्रिय एयरलाइनें',
            items: [
                { title: 'अमेरिकन एयरलाइन्स', href: 'https://www.wingie.de/hi/flights/airlines/american-airlines/' },
                { title: 'डेल्टा एयरलाइन्स', href: 'https://www.wingie.de/hi/flights/airlines/delta-air-lines/' },
                { title: 'यूनाइटेड एयरलाइन्स', href: 'https://www.wingie.de/hi/flights/airlines/united-airlines/' },
                { title: 'अलास्का एयरलाइन्स', href: 'https://www.wingie.de/hi/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.de/hi/flights/airlines/jetblue/' },
                { title: 'हवाई एयरलाइन्स', href: 'https://www.wingie.de/hi/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'de-ta': [
        {
            title: 'பிரபலமான இலக்குகள்',
            items: [
                { title: 'லாஸ் வெகாஸ்', href: 'https://www.wingie.de/ta/flights/to-las-vegas/' },
                { title: 'சிகாகோ', href: 'https://www.wingie.de/ta/flights/to-chicago/' },
                { title: 'மியாமி', href: 'https://www.wingie.de/ta/flights/to-miami/' },
                { title: 'கான்கன்', href: 'https://www.wingie.de/ta/flights/to-cancun/' },
                { title: 'லண்டன்', href: 'https://www.wingie.de/ta/flights/to-london/' },
                { title: 'ஓனோலுலு', href: 'https://www.wingie.de/ta/flights/to-honolulu/' },
            ],
        },
        {
            title: 'பிரபலமான நாடுகள்',
            items: [
                { title: 'கனடா', href: 'https://www.wingie.de/ta/flights/ca-canada/' },
                { title: 'சீனா', href: 'https://www.wingie.de/ta/flights/cn-china/' },
                { title: 'கோஸ்டா ரிக்கா', href: 'https://www.wingie.de/ta/flights/cr-costa-rica/' },
                { title: 'டொமினிக்கன் குடியரசு', href: 'https://www.wingie.de/ta/flights/do-dominican-republic/' },
                { title: 'எல் சால்வடோர்', href: 'https://www.wingie.de/ta/flights/sv-el-salvador/' },
                { title: 'பிரான்சு', href: 'https://www.wingie.de/ta/flights/fr-france/' },
            ],
        },
        {
            title: 'பிரபலமான விமான நிறுவனங்கள்',
            items: [
                { title: 'அமெரிக்கன் ஏர்லைன்ஸ்', href: 'https://www.wingie.de/ta/flights/airlines/american-airlines/' },
                { title: 'டெல்டா ஏர்லைன்ஸ்', href: 'https://www.wingie.de/ta/flights/airlines/delta-air-lines/' },
                { title: 'யுனைட்டட் ஏர்லைன்ஸ்', href: 'https://www.wingie.de/ta/flights/airlines/united-airlines/' },
                { title: 'அலாஸ்கா ஏர்லைன்ஸ்', href: 'https://www.wingie.de/ta/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.de/ta/flights/airlines/jetblue/' },
                { title: 'ஹவாய் ஏர்லைன்ஸ்', href: 'https://www.wingie.de/ta/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'de-th': [
        {
            title: 'จุดหมายยอดนิยม',
            items: [
                { title: 'ลาสเวกัส', href: 'https://www.wingie.de/th/flights/to-las-vegas/' },
                { title: 'ชิคาโก', href: 'https://www.wingie.de/th/flights/to-chicago/' },
                { title: 'ไมอามี', href: 'https://www.wingie.de/th/flights/to-miami/' },
                { title: 'แคนคูน', href: 'https://www.wingie.de/th/flights/to-cancun/' },
                { title: 'ลอนดอน', href: 'https://www.wingie.de/th/flights/to-london/' },
                { title: 'โฮโนลูลู', href: 'https://www.wingie.de/th/flights/to-honolulu/' },
            ],
        },
        {
            title: 'ประเทศยอดนิยม',
            items: [
                { title: 'แคนาดา', href: 'https://www.wingie.de/th/flights/ca-canada/' },
                { title: 'จีน', href: 'https://www.wingie.de/th/flights/cn-china/' },
                { title: 'คอสตาริกา', href: 'https://www.wingie.de/th/flights/cr-costa-rica/' },
                { title: 'สาธารณรัฐโดมินิกัน', href: 'https://www.wingie.de/th/flights/do-dominican-republic/' },
                { title: 'เอลซัลวาดอร์', href: 'https://www.wingie.de/th/flights/sv-el-salvador/' },
                { title: 'ฝรั่งเศส', href: 'https://www.wingie.de/th/flights/fr-france/' },
            ],
        },
        {
            title: 'สายการบินยอดนิยม',
            items: [
                { title: 'อเมริกันแอร์ไลน์', href: 'https://www.wingie.de/th/flights/airlines/american-airlines/' },
                { title: 'เดลต้า แอร์ไลน์', href: 'https://www.wingie.de/th/flights/airlines/delta-air-lines/' },
                { title: 'ยูไนเต็ด แอร์ไลน์', href: 'https://www.wingie.de/th/flights/airlines/united-airlines/' },
                { title: 'อลาสก้าแอร์ไลน์', href: 'https://www.wingie.de/th/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.de/th/flights/airlines/jetblue/' },
                { title: 'ฮาวายแอนแอร์ไลน์', href: 'https://www.wingie.de/th/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'de-ur': [
        {
            title: 'مشہور منزلیں',
            items: [
                { title: 'لاس ویگاس', href: 'https://www.wingie.de/ur/flights/to-las-vegas/' },
                { title: 'شکاگو', href: 'https://www.wingie.de/ur/flights/to-chicago/' },
                { title: 'میامی', href: 'https://www.wingie.de/ur/flights/to-miami/' },
                { title: 'کینکن', href: 'https://www.wingie.de/ur/flights/to-cancun/' },
                { title: 'لندن', href: 'https://www.wingie.de/ur/flights/to-london/' },
                { title: 'ہونولولو', href: 'https://www.wingie.de/ur/flights/to-honolulu/' },
            ],
        },
        {
            title: 'مشہور ممالک',
            items: [
                { title: 'کینیڈا', href: 'https://www.wingie.de/ur/flights/ca-canada/' },
                { title: 'چین', href: 'https://www.wingie.de/ur/flights/cn-china/' },
                { title: 'کوسٹا ریکا', href: 'https://www.wingie.de/ur/flights/cr-costa-rica/' },
                { title: 'ڈومینیکن جمہوریہ', href: 'https://www.wingie.de/ur/flights/do-dominican-republic/' },
                { title: 'ایل سیلواڈور', href: 'https://www.wingie.de/ur/flights/sv-el-salvador/' },
                { title: 'فرانس', href: 'https://www.wingie.de/ur/flights/fr-france/' },
            ],
        },
        {
            title: 'مشہور ایئر لائنز',
            items: [
                { title: 'امریکن ایئرلائنز', href: 'https://www.wingie.de/ur/flights/airlines/american-airlines/' },
                { title: 'ڈیلٹا ایئر لائنز', href: 'https://www.wingie.de/ur/flights/airlines/delta-air-lines/' },
                { title: 'یونائیٹڈ ایئرلائنز', href: 'https://www.wingie.de/ur/flights/airlines/united-airlines/' },
                { title: 'الاسکا ایئرلائنز', href: 'https://www.wingie.de/ur/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.de/ur/flights/airlines/jetblue/' },
                { title: 'ہوائی ایئرلائنز', href: 'https://www.wingie.de/ur/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'de-ka': [
        {
            title: 'პოპულარული მიმართულებები',
            items: [
                { title: 'ლას-ვეგასი', href: 'https://www.wingie.de/ka/flights/to-las-vegas/' },
                { title: 'ჩიკაგო', href: 'https://www.wingie.de/ka/flights/to-chicago/' },
                { title: 'მაიამი', href: 'https://www.wingie.de/ka/flights/to-miami/' },
                { title: 'კანკუნი', href: 'https://www.wingie.de/ka/flights/to-cancun/' },
                { title: 'ლონდონი', href: 'https://www.wingie.de/ka/flights/to-london/' },
                { title: 'ჰონოლულუ', href: 'https://www.wingie.de/ka/flights/to-honolulu/' },
            ],
        },
        {
            title: 'პოპულარული ქვეყნები',
            items: [
                { title: 'კანადა', href: 'https://www.wingie.de/ka/flights/ca-canada/' },
                { title: 'ჩინეთი', href: 'https://www.wingie.de/ka/flights/cn-china/' },
                { title: 'კოსტა-რიკა', href: 'https://www.wingie.de/ka/flights/cr-costa-rica/' },
                { title: 'დომინიკელთა რესპუბლიკა', href: 'https://www.wingie.de/ka/flights/do-dominican-republic/' },
                { title: 'სალვადორი', href: 'https://www.wingie.de/ka/flights/sv-el-salvador/' },
                { title: 'საფრანგეთი', href: 'https://www.wingie.de/ka/flights/fr-france/' },
            ],
        },
        {
            title: 'პოპულარული ავიაკომპანიები',
            items: [
                { title: 'ამერიკის ავიაკომპანია', href: 'https://www.wingie.de/ka/flights/airlines/american-airlines/' },
                { title: 'დელტა ეარ ლაინზი', href: 'https://www.wingie.de/ka/flights/airlines/delta-air-lines/' },
                { title: 'იუნაიტედ ერლაინზი', href: 'https://www.wingie.de/ka/flights/airlines/united-airlines/' },
                { title: 'ალასკას ავიაკომპანია', href: 'https://www.wingie.de/ka/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.de/ka/flights/airlines/jetblue/' },
                { title: 'ჰავაუს ავიაკომპანია', href: 'https://www.wingie.de/ka/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ]
}